var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 77 77",
    width: 77,
    height: 77,
    style: {
      enableBackground: "new 0 0 77 77"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D1EFFE;}\r\n\t.st1{fill:#73C7EF;}\r\n\t.st2{fill:#6EC5EE;}\r\n\t.st3{fill:#8BD0F2;}\r\n\t.st4{fill:#83CDF1;}\r\n\t.st5{fill:#1E73BD;}\r\n\t.st6{fill:#76CAF1;}\r\n\t.st7{fill:#D8F4FE;}\r\n\t.st8{fill:#5F9ED4;}\r\n\t.st9{fill:#156FBB;}\r\n\t.st10{fill:#1F74BE;}\r\n\t.st11{fill:#FEFEFE;}\r\n\t.st12{fill:#0068B9;}\r\n\t.st13{fill:#006CBA;}\r\n\t.st14{fill:#2275BE;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1,42.2c0-2.8,0-5.6,0-8.4c0.3-5.8,2.2-11.1,5.3-16c5.5-8.6,13.1-14.4,23-17C31.1,0.3,33,0.4,34.8,0 c2.7,0,5.4,0,8.1,0c4.9,0.2,9.5,1.5,13.8,3.8c9.6,5.2,16.1,13,19.3,23.5c0.7,2.2,0.6,4.5,1,6.8c0,2.7,0,5.4,0,8.1 c-0.4,0.6,0.2,1.5-0.5,2.1c-1.1,0.2-1.6-0.7-2.2-1.3c-9-9-18-17.9-27-26.9c-0.3-0.3-0.5-0.6-0.9-0.8c-0.2-0.1-0.4-0.3-0.6-0.3 c-3.2,0.1-6.3,1.1-9.4,1.5c-4,0.6-7.9,1.4-11.9,2.1c-2.5,0.4-5,0.7-7.4,1.4c-0.1,0.1-0.2,0.2-0.3,0.4c-0.1,0.4-0.1,0.9-0.1,1.3 c0,10.8,0,21.6,0,32.5c0,0.4,0,0.9,0.1,1.3c0.1,0.2,0.1,0.3,0.2,0.5c5.8,6,11.8,11.8,17.7,17.8c0.6,0.6,1.6,1.1,1.1,2.2 c-0.3,0-0.7,0-1,0c-5.8-0.3-11.1-2.2-16-5.3c-8.6-5.5-14.4-13.1-17-23C1.3,45.9,1.4,44,1,42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.8,76c0-0.8-0.7-1.2-1.2-1.7c-5.9-5.9-11.8-11.9-17.7-17.8c0.1-0.1,0.1-0.1,0.2-0.2 c0.2-0.1,0.4-0.2,0.5-0.2c5.3,0.6,10.5,1.8,15.8,2.6c3.5,0.6,7,1.2,10.5,1.8c0.6,0.1,1.3,0.5,1.9-0.2c0.5-0.7,0.4-1.5,0.4-2.3 c0-13.6,0-27.1,0-40.7c0-0.9-0.3-1.8,0.5-2.6c2,2,4,3.9,6,5.9c7.4,7.4,14.9,14.9,22.3,22.3c0.4,0.4,0.9,0.8,1.4,1.2 c0.7,1.1,0.2,2.2-0.1,3.2c-1.4,5.7-4,10.7-7.7,15.2c-4.9,5.8-11,9.9-18.3,12.1c-2.1,0.6-4.1,1-6.3,1c-1-0.2-2-0.2-3-0.1 c-0.4,0.2-0.8-0.1-1.2,0.3c-0.5,0-0.9,0-1.4,0c-0.8-0.3-1.6-0.3-2.4,0C36,76,35.9,76,35.8,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.9,75.6c-0.3,0.1-0.8,0-1,0.4c-0.5,0-0.9,0-1.4,0c-0.2-0.2-0.5-0.1-0.7-0.3C41.9,75.1,42.9,75.1,43.9,75.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.1,76c0.8-0.5,1.6-0.5,2.4,0C37.7,76,36.9,76,36.1,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M40.9,75.6c0.3,0,0.5,0.1,0.7,0.3c-0.6,0-1.1,0-1.7,0C40.1,75.6,40.5,75.6,40.9,75.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M46.2,61.5c-9.7-1.7-19.3-3.4-29-5.1c-0.7-0.7-0.5-1.6-0.5-2.4c0-10.4,0-20.8,0-31.2c0-0.8,0-1.7-0.1-2.5 c-0.1-0.3,0-0.7,0.2-0.9c2.1-0.5,4.2-0.7,6.4-1.1c5.3-0.8,10.4-2,15.7-2.7c2.1-0.3,4.2-0.8,6.2-1.2c0.4-0.1,0.8-0.3,1.1,0.1 c0.2,0.4,0.1,0.9,0.1,1.3c0,14.7,0,29.4,0,44.2C46.4,60.5,46.6,61,46.2,61.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M46.2,61.5c0-14.9,0-29.8,0-44.8c0-0.7,0-1.5,0.1-2.2c0.1,0.1,0.2,0.2,0.3,0.3c0,14.9,0,29.7,0,44.6 C46.6,60.1,46.9,60.9,46.2,61.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M16.6,56.4c-0.6-0.5-0.4-1.1-0.4-1.7c0-11.2,0-22.4,0-33.7c0-0.6-0.2-1.3,0.4-1.7c0.2,0.8,0.3,1.7,0.3,2.5 c0,10.9,0,21.8,0,32.6C16.9,55.1,17,55.8,16.6,56.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M16.6,56.4c0-12.4,0-24.7,0-37.1c0.1,0,0.2,0,0.3,0c0,0.2,0,0.4,0,0.6c0.2,0.4,0.1,0.8,0.1,1.2 c0,11.3,0,22.7,0,34c0,0.4,0.1,0.8-0.1,1.2c0,0-0.1,0.1-0.1,0.1C16.8,56.4,16.7,56.4,16.6,56.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M61.3,40.9c-0.8,0-1.6,0-2.4,0c-0.6,0-1.1,0.1-1.3,0.7c-0.2,0.6-0.1,1.1,0.3,1.5c0.3,0.3,0.6,0.5,0.8,0.8 c0.2,0.3,0.4,0.7,0.5,1.1c0.1,0.3-3.5,3.9-3.7,3.8c-0.4-0.2-0.8-0.5-1-0.8c-0.8-1.2-1.8-1.5-3.1-0.7c-0.5,1-0.3,2-0.1,3 c-0.8,0.6-1.8,0.2-2.7,0.3c-0.4-2.6-0.3-5.2,0-7.8c4.3-1.1,6.1-4.5,4.1-7.7c-0.9-1.5-2.5-1.9-4.1-2.4c-0.2-2.6-0.4-5.2,0.1-7.8 c0.9,0.2,1.8-0.3,2.6,0.3c-0.2,1-0.4,2,0.1,3c1.2,0.8,2.1,0.7,3-0.5c0.8-1,1.5-0.9,2.3,0c0.3,0.3,0.6,0.6,0.9,1 c1.8,1.8,1.9,1.9,0.2,3.9c-0.4,0.5-0.4,0.8-0.2,1.4c0.2,0.6,0.6,0.7,1.2,0.7c0.9,0,1.8-0.2,2.6,0.3C61.7,37.1,61.8,39,61.3,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M16.9,56.3c0-12.1,0-24.2,0-36.3c0.5,0.5,0.3,1.2,0.3,1.8c0,11.5,0,23.1,0,34.6c0,0-0.2,0-0.2,0L16.9,56.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M48.7,35.1c1.5,0.3,2.7,1.2,2.6,2.9c-0.1,1.4-1,2.4-2.6,2.5C48.4,38.7,48.3,36.9,48.7,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M48.7,25c0,2.6,0,5.2-0.1,7.8c-0.8-1.8-0.2-3.7-0.3-5.6C48.3,26.5,48,25.6,48.7,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M48.6,42.9c0,2.6,0,5.2,0,7.8C48,48.1,48.1,45.5,48.6,42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M61.3,40.9c0-1.9,0.1-3.8,0.1-5.7C62,37.1,62.1,39,61.3,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M48.7,35.1c0,1.8,0,3.6,0,5.4C48.1,38.7,48,36.9,48.7,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M51.4,28.4c-0.7-1-0.6-2-0.1-3C51.3,26.4,51.4,27.4,51.4,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M51.3,50.3c-0.5-1-0.7-2,0.1-3C51.4,48.3,51.4,49.3,51.3,50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M28.1,42.3c-0.9,1.2-1.1,2.8-1.7,4.2c-1.1,0.5-2.2,0.5-3.3,0c1.1-3.9,2.8-7.5,4.2-11.3 c0.6-1.6,1.2-3.3,1.8-4.9c0.3-0.7,0.7-1.1,1.5-1c0.8,0.1,1.8-0.4,2.2,0.7c2,5.5,4.4,10.9,6.1,16.5c-1.1,0.4-2.2,0.5-3.3,0 c-0.6-1.4-0.9-2.9-1.7-4.2C31.8,42.4,29.9,42.4,28.1,42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M28.1,42.3c1.9-0.2,3.8-0.2,5.7,0C31.8,42.7,29.9,42.7,28.1,42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M23,46.5c1.1,0,2.2,0,3.3,0C25.2,47.3,24.1,47.2,23,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M35.5,46.5c1.1,0,2.2,0,3.3,0C37.7,47.2,36.6,47.2,35.5,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M31.9,29c-0.7,0-1.4,0-2.1,0c0-0.1,0-0.1,0-0.2c0.7,0,1.4,0,2.1,0C32,28.9,32,28.9,31.9,29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M30.9,39.8c-2.5,0-2.5,0-1.6-2.4c0.3-0.9,0.6-1.8,1-2.7c0.1-0.3,0.1-0.7,0.6-0.7c0.4,0,0.5,0.4,0.6,0.7 c0.4,1.2,0.8,2.4,1.3,3.6c0.5,1.1,0.3,1.7-1,1.5C31.5,39.8,31.2,39.8,30.9,39.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.7713d1f50ed8955b1ccf7fd2abfefbdf.svg";
export { ForwardRef as ReactComponent };